<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Support Request</span> 
          <span v-else>Create a New Support Request</span>
        </h1>
        <span>
          <router-link :to="{name: 'support-requests'}" class="btn btn_black">Back to List</router-link>
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
                <div :class="['form_row', {'has_error': errorFor('company_id')}]">
                  <label class="required">Company</label>
                    <Multiselect
                      v-model="selectedCompany"
                      :options="companies"
                      :multiple="false"
                      :close-on-select="true"
                      placeholder="Select a company"
                      label="company_name"
                      :optionHeight="20"
                      track-by="id"
                      @Select="onCompanySelect"
                      @remove="onCompanyRemove"
                    />
                    <v-errors :errors="errorFor('company_id')"></v-errors>
                </div>
                <div :class="['form_row', {'has_error': errorFor('contact_id')}]">
                  <label class="required">Contact</label>
                    <Multiselect
                      v-model="selectedContact"
                      :options="contacts"
                      :multiple="false"
                      :close-on-select="true"
                      placeholder="Select a contact"
                      label="name"
                      :optionHeight="20"
                      track-by="id"
                      @Select="onContactSelect"
                      @remove="onContactRemove"
                    />
                    <v-errors :errors="errorFor('contact_id')"></v-errors>
                </div>
              <div :class="['form_row', {'has_error': errorFor('subject')}]">
                <label class="required">Subject</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="contact.subject">
                  <v-errors :errors="errorFor('subject')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('group_id')}]">
                <label class="required">Group</label>
                <div class="form_input">
                  <select class="form_global" v-model="contact.group_id">
                    <option value="">Select Group</option>
                    <option v-for="group in groups" :key="group.id" :value="group.id">
                      {{ group.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('group_id')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('request_from')}]">
                <label class="required">Request from</label>
                <div class="form_input">
                  <select class="form_global" v-model="contact.request_from">
                    <option value="">Select request from</option>
                    <option value="phone">Phone</option>
                    <option value="website">Website</option>
                    <option value="email">Email</option>
                    <option value="chat">Chat</option>
                    <option value="other">Other</option>
                  </select>
                  <v-errors :errors="errorFor('request_from')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              
              <div :class="['form_row', {'has_error': errorFor('message')}]">
                <label>Message</label>
                <div class="form_inline">
                    <text-editor v-model:text="contact['message']" :id="'message'"></text-editor>
                    <v-errors :errors="errorFor('message')"></v-errors>
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline ">
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="update" v-if="$route.params.id">Update</button>
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="submit" v-else>Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
    import TextEditor from "@/components/shared/TextEditor";
    import Multiselect from 'vue-multiselect';
    export default {
        name: 'support-request-form',
        components: {LoaderMaskComponent, TextEditor, Multiselect},
        data(){
            return {
              lyLoading: false,
              selectedCompany: null,
              selectedContact: null,
              contact: {
                company_id: '',
                contact_id: '',
                company_name: '',
                name: '',
                email: '',
                phone: '',
                title: '',
                group_id: '',
                subject: '',
                message: '',
                request_from: '',
                terms: 1,
              },
              companies: [],
              contacts: [],
              groups: [],
            }
        },
        created() {
            if(this.$route.params.id){
              this.loadData(this.$route.params.id)
            }
            this.getCompanies()
            this.getGroups()
        },
        methods: {
          getCompanies() {
            this.axios.get('/active-companies-for-relation').then(({data}) => {
              this.companies = data.data
              if(this.contact.company_id){
                  var company = this.companies.filter(company => company.id == this.contact.company_id);
                  if(company && company.length > 0){
                      this.selectedCompany = company[0];
                      this.contacts = company[0].contacts;
                      var contact = this.contacts.filter(contact => contact.id == this.contact.contact_id);
                      if(contact && contact.length > 0){
                        this.selectedContact = contact[0];
                      }
                  }
              }
            })
          },
          getGroups() {
            this.axios.get('/active-groups-for-relation').then(({data}) => {
              this.groups = data.data
            })
          },
          onCompanySelect(selected){
            this.contact.company_id = selected.id
            this.contact.company_name = selected.company_name
            this.contacts = selected.contacts
            this.selectedContact = null
            this.contact.contact_id = ''
            this.contact.name = ''
            this.contact.email = ''
            this.contact.phone = ''
            this.contact.title = ''
          },
          onCompanyRemove(){
            this.contact.company_id = ''
            this.contact.company_name = ''
            this.contacts = []
            this.selectedCompany = null
            this.selectedContact = null
            this.contact.contact_id = ''
            this.contact.name = ''
            this.contact.email = ''
            this.contact.phone = ''
            this.contact.title = ''
          },
          onContactSelect(selected){
            this.contact.contact_id = selected.id
            this.contact.name = selected.name
            this.contact.email = selected.email
            this.contact.phone = selected.phone
            this.contact.title = selected.title
          },
          onContactRemove(){
            this.contact.contact_id = ''
            this.contact.name = ''
            this.contact.email = ''
            this.contact.phone = ''
            this.contact.title = ''
            this.selectedContact = null
          },
          loadData(contactId){
              this.lyLoading = true;
              this.axios.get('/support-requests/'+contactId)
              .then((response) => {
                this.contact = response.data.data;
              })
              .catch(() => {
                  this.showFailMsg("No contact exists!");
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          submit() {
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              Object.keys(this.contact).forEach(key => {
                  formData.append(key, this.contact[key] ? this.contact[key] : '');
              })

              this.axios.post('/support-requests', formData)
              .then(() => {
                  this.resetForm();
                  this.showSuccessMsg("Support Request Created Successfully!");
                  this.$router.push({ name: 'support-requests'})
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
                  this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                  this.lyLoading = false;
              })

          },
          update(){
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              formData.append('_method','PATCH')

              Object.keys(this.contact).forEach(key => {
                formData.append(key, this.contact[key] ? this.contact[key] : '');
              })

              this.axios.post('/support-requests/'+this.$route.params.id, formData)
              .then(() => {
                  this.showSuccessMsg("Support Request Update Successfully!");
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          resetForm(){
              this.contact = {
                company_id: '',
                contact_id: '',
                company_name: '',
                name: '',
                email: '',
                phone: '',
                title: '',
                group_id: '',
                subject: '',
                message: '',
                request_from: '',
                terms: 1,
              }
          },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
  .create_item_tab button {
    position: relative;
    float: right;
    right: 0;
    top: 0;
  }
  .btn_back{
    position: relative;
    float: right;
    right: 0;
    top: 0;
  }
  .font_italic{
    position: relative;
    display: block;
    left: 120px;
    padding-top: 5px;
  }

  .multiselect{
    height: 50px;
  }
</style>
